module.exports = __webpack_public_path__ + "static/tebco-logo-3610c2c542d75ebbe00462e9d3ca4d37.jpg";